import { useStoreActions, useStoreState } from '@discover-data/stores/restaurant/hooks';

export default function usePage() {
  const limit = useStoreState((state) => state.page.limit);
  const resetPage = useStoreActions((actions) => actions.page.resetPage);
  const nextPage = useStoreActions((actions) => actions.page.nextPage);
  const hasNextPage = useStoreState((state) => state.hasNextPage);

  return { limit, resetPage, nextPage, hasNextPage };
}
